import React from "react";
import { FiUsers, FiTrendingUp, FiMapPin } from "react-icons/fi";

const OfficeManagerDashboard = ({ user }) => {
  return (
    <div className="p-6 space-y-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Office Manager Dashboard</h2>
        <p className="text-gray-600">Region: {user.state}, {user.district}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Total Users" value="0" icon={<FiUsers size={24} />} color="blue" />
        <StatCard title="Active Members" value="0" icon={<FiTrendingUp size={24} />} color="green" />
        <StatCard title="Team Income" value="₹0" icon={<FiTrendingUp size={24} />} color="purple" />
        <StatCard title="Your Commission" value="₹0" icon={<FiTrendingUp size={24} />} color="orange" />
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4">Team Overview</h3>
        <p className="text-gray-500 text-center py-8">Loading team data...</p>
      </div>
    </div>
  );
};

const MPCDashboard = ({ user }) => {
  return (
    <div className="p-6 space-y-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Pickup Center Dashboard</h2>
        <p className="text-gray-600">Location: {user.pickupLocation?.state}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Pending Pickups" value="0" icon={<FiMapPin size={24} />} color="orange" />
        <StatCard title="Shipped" value="0" icon={<FiTrendingUp size={24} />} color="blue" />
        <StatCard title="Delivered" value="0" icon={<FiTrendingUp size={24} />} color="green" />
        <StatCard title="Total Handled" value="0" icon={<FiUsers size={24} />} color="purple" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Pending Shipments</h3>
          <p className="text-gray-500 text-center py-8">No pending shipments</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Recent Activity</h3>
          <p className="text-gray-500 text-center py-8">No recent activity</p>
        </div>
      </div>
    </div>
  );
};

const MobileStoreDashboard = ({ user }) => {
  return (
    <div className="p-6 space-y-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Mobile Store Dashboard</h2>
        <p className="text-gray-600">Store ID: {user.uniqueId}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Total Orders" value="0" icon={<FiUsers size={24} />} color="blue" />
        <StatCard title="Order Value" value="₹0" icon={<FiTrendingUp size={24} />} color="green" />
        <StatCard title="Commission" value="₹0" icon={<FiTrendingUp size={24} />} color="purple" />
        <StatCard title="E-Wallet" value="₹0" icon={<FiTrendingUp size={24} />} color="orange" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Recent Orders</h3>
          <p className="text-gray-500 text-center py-8">No orders yet</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4">Delivery Status</h3>
          <div className="space-y-3">
            <div className="flex justify-between"><span>Pending</span><span className="font-bold">0</span></div>
            <div className="flex justify-between"><span>Shipped</span><span className="font-bold">0</span></div>
            <div className="flex justify-between"><span>Delivered</span><span className="font-bold">0</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ title, value, icon, color }) => {
  const colorClasses = {
    blue: "bg-blue-50 text-blue-600",
    green: "bg-green-50 text-green-600",
    purple: "bg-purple-50 text-purple-600",
    orange: "bg-orange-50 text-orange-600"
  };

  return (
    <div className={`${colorClasses[color]} rounded-lg shadow p-6`}>
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-gray-700 font-semibold text-sm">{title}</h4>
        <div className={colorClasses[color]}>{icon}</div>
      </div>
      <div className="text-3xl font-bold text-gray-800">{value}</div>
    </div>
  );
};

export { OfficeManagerDashboard, MPCDashboard, MobileStoreDashboard };
